import { Link } from './link.model';
import { Field } from './field.model';
import { ESchemaContentStatus } from '../../akita/base/enum';
import { ScheduleJob } from './schedule-Job.model';

export abstract class Content {
  created: Date;
  createdBy: string;
  data: any;
  id: string;
  lastModified: Date;
  lastModifiedBy: string;
  schemaName: string;
  schemaDisplayName: string;
  referenceFields: Field[];
  scheduleJob: ScheduleJob;
  status: string;
  newStatus: string;
  statusColor: string;
  newStatusColor: string;
  version: number;
  _links: { [id: string]: Link };

  constructor({
    created,
    createdBy,
    data,
    id,
    lastModified,
    lastModifiedBy,
    schemaName,
    schemaDisplayName,
    referenceFields,
    scheduleJob,
    status,
    newStatus,
    statusColor,
    newStatusColor,
    version,
    _links
  }: Partial<Content>) {
    this.created = created;
    this.createdBy = createdBy;
    this.id = id;
    this.lastModified = lastModified;
    this.lastModifiedBy = lastModifiedBy;
    this.schemaName = schemaName;
    this.schemaDisplayName = schemaDisplayName;
    this.referenceFields = referenceFields;
    this.scheduleJob = scheduleJob;
    this.status = status;
    this.newStatus = newStatus;
    this.statusColor = statusColor;
    this.newStatusColor = newStatusColor;
    this.version = version;
    this._links = _links;

    if (!data) {
      data = {};
    }
    this.data = data;
  }

  isPublished(): boolean {
    return this.status && this.status.toLowerCase() === 'published';
  }

  getStatus(): ESchemaContentStatus {
    switch (this.status && this.status.toLowerCase()) {
      case 'published':
        return ESchemaContentStatus.Draft;
      case 'draft':
        return ESchemaContentStatus.Draft;
      default: return ESchemaContentStatus.All;
    }
  }
}
